import { revokeSessionElevation } from "@/api/stepUp";
import { useMutation } from "@tanstack/react-query";

export const useRevokeSessionElevation = () => {
  return useMutation({
    mutationFn: revokeSessionElevation,
  });
};
